import {
  CANADA_COUNTRY_ID,
  DHL_DELIVERY_SERVICE, DHLPL_DELIVERY_SERVICE,
  FEDEX_DELIVERY_SERVICE,
  NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE, NOVAPOSHTA_INTERNATIONAL_DELIVERY_SERVICE,
  POLAND_COUNTRY_ID,
  PYRZOWICE_WAREHOUSE,
  TNT_DELIVERY_SERVICE, UPS_DELIVERY_SERVICE,
  USA_COUNTRY_ID
} from "../../staticData/staticVariables";
import {countriesMixin} from "../commonMixins/countriesMixin";

export const expressCountriesMixin = {

  mixins: [countriesMixin],

  methods: {
    getDeliveryCountries() {
      let filter = ''

      let userContact = this.getUserContactWithCheckAlternative(this.ex.express.user)
      let actualAddressUkraine = this.isUseAlternativeContact ? this.isUserAlternativeContactUkraine : this.isUkrainian

      if(actualAddressUkraine && Number(this.ex.express.type) === FEDEX_DELIVERY_SERVICE.id &&
        (this.ex.express.sendType === this.ex.express.sendTypes.warehouse && this.ex.express.warehouse?.id)) {
        filter = '?filter[byWarehouseId]=' + this.ex.express.warehouse?.id + `&filter[byOrderType]=express&filter[byDeliveryServiceId]=${FEDEX_DELIVERY_SERVICE.id}`
      }

      if(actualAddressUkraine && Number(this.ex.express.type) === UPS_DELIVERY_SERVICE.id &&
        (this.ex.express.sendType === this.ex.express.sendTypes.warehouse && this.ex.express.warehouse?.id)) {
        filter = '?filter[byWarehouseId]=' + this.ex.express.warehouse?.id + `&filter[byOrderType]=express&filter[byDeliveryServiceId]=${UPS_DELIVERY_SERVICE.id}`
      }

      if(Number(this.ex.express.type) === DHL_DELIVERY_SERVICE.id) {
        if(this.ex.express.sendType === this.ex.express.sendTypes.warehouse && this.ex.express.warehouse?.id) {
          filter = `?filter[byWarehouseId]=${this.ex.express.warehouse?.id}` + `&filter[byOrderType]=express&filter[byDeliveryServiceId]=${DHL_DELIVERY_SERVICE.id}`
        } else if(userContact) {
          filter = `?filter[bySenderCountryId]=${userContact?.country_id}` + `&filter[byOrderType]=express&filter[byDeliveryServiceId]=${DHL_DELIVERY_SERVICE.id}`
        }

      }

      if(Number(this.ex.express.type) === DHLPL_DELIVERY_SERVICE.id) {
        filter = `?filter[onlyEUCountries]=1`
      }

      if(Number(this.ex.express.type) === NOVAPOSHTA_INTERNATIONAL_DELIVERY_SERVICE.id) {
        filter = `?filter[withoutNPICountries]=1`
      }

      this.$store.dispatch('fetchCountries', filter).then(() => {
        let countries = this._.toArray(this.$store.getters.getCountries)

        switch (this.ex.express.type) {
          case TNT_DELIVERY_SERVICE.id:
            if(this.getUserTntAllCountriesSetting)
              return this.options = this.getCountriesForRecipient(countries)
            this.options = this.removeCountryById(countries, [
              USA_COUNTRY_ID,
              CANADA_COUNTRY_ID,
            ])
            break
          case DHL_DELIVERY_SERVICE.id:
            this.options = this.getCountriesForRecipient(countries)
            if(this.ex.express.warehouse?.id === PYRZOWICE_WAREHOUSE.id) {
              this.options = this.removeCountryById(this.options, [
                POLAND_COUNTRY_ID,
              ])
            }
            break
          case DHLPL_DELIVERY_SERVICE.id:
            this.options = this.getCountriesForRecipient(countries)
            break
          case FEDEX_DELIVERY_SERVICE.id:
            this.options = this.getCountriesForRecipient(countries)
            // this.options = this.removeCountryById(this.options, [
            //   POLAND_COUNTRY_ID,
            // ])
            break
          case NOVAPOSHTA_GLOBAL_DELIVERY_SERVICE.id:
            this.options = this.getCountriesForRecipient(countries)
            // this.options = this.removeCountryById(this.options, [
            //   POLAND_COUNTRY_ID,
            // ])
            break
          case UPS_DELIVERY_SERVICE.id:
            this.options = this.getCountriesForRecipient(countries)
            // this.options = this.removeCountryById(this.options, [
            //   POLAND_COUNTRY_ID,
            // ])
            break
          case NOVAPOSHTA_INTERNATIONAL_DELIVERY_SERVICE.id:
            this.options = this.getCountriesForRecipient(countries)
            // this.options = this.removeCountryById(this.options, [
            //   POLAND_COUNTRY_ID,
            // ])
            break
        }

      })
    }
  }
}
